import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const NotFound = lazy(() => import('../../container/pages/404'));
const UploadQwikFile = lazy(() => import('../../container/settings/uploadQwikFile'));

function MerchantGroupsRoute() {
  return (
    <Routes>
      <Route path="/" element={<UploadQwikFile />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default MerchantGroupsRoute;
